import { api } from '@/lib/api';
import type { UserMcpTokenMetadata, CreateMcpTokenResponse } from '@troia-v3/types';

export const mcpApi = {
  async getMetadata(): Promise<UserMcpTokenMetadata> {
    const response = await api.get<{ success: boolean; data: UserMcpTokenMetadata }>('users/me/mcp-token');
    return response.data.data;
  },

  async generate(): Promise<CreateMcpTokenResponse> {
    const response = await api.post<{ success: boolean; data: CreateMcpTokenResponse }>('users/me/mcp-token');
    return response.data.data;
  },

  async revoke(): Promise<void> {
    await api.delete('users/me/mcp-token');
  },
};
